import { PayloadAction } from '@reduxjs/toolkit';
import NoticeDetail from '@/components/pages/user/community/notice/notice-detail';
import i18n from '@/i18n';
import type {
  ICommonBoardFaqTypeList,
  ICommonBoardFaqTypes, IEmailQuestion, IPublicBoard, IPublicBoardOne, PublicBoardName,
} from '../../types';
import { createSliceSteamup } from '../common';

type IPublicBoardState = {
  notice: IPublicBoardOne;
  library: IPublicBoardOne;
  qna: IPublicBoardOne;
  faq: IPublicBoardOne;
  noticeDetail: IPublicBoard;
  faqDetail: IPublicBoard;
  faqType: ICommonBoardFaqTypes[];
  noticeTitle: string;
  emailQuestion: IEmailQuestion[],
  emailDetail: IEmailQuestion,
};

const communityBoardSlice = createSliceSteamup(
  'publicBoard',
  {
    notice: { total: 0, loading: true },
    library: { total: 0, loading: true },
    qna: { total: 0, loading: true },
    faq: { total: 0, loading: true },
    noticeDetail: {},
    faqType: {},
    emailQuestion: {},
    emailDetail: {},
  } as IPublicBoardState,
  {
    setData(state, { payload }: PayloadAction<{ type: PublicBoardName, data: IPublicBoardOne}>) {
      state[payload.type] = payload.data;
    },
    setNoticeDetailData(state, { payload }: PayloadAction<(typeof state.noticeDetail)>) {
      state.noticeDetail = payload;
    },
    setFaqDetailData(state, { payload }: PayloadAction<(typeof state.faqDetail)>) {
      state.faqDetail = payload;
    },
    setFaqTypeData(state, { payload }: PayloadAction<(typeof state.faqType)>) {
      state.faqType = payload;
    },
    // 타입 삭제 반영
    deleteFaqType(state, { payload }: PayloadAction<number>) {
      const deleteIndex = state.faqType.findIndex((type) => type.id === payload);
      if (deleteIndex >= 0) {
        state.faqType.splice(deleteIndex, 1);
      }
    },
    // 공지사항 제목 수정(+ 언어 변환)
    setKoNoticeTitleChange(state, { payload }: PayloadAction<string>) {
      if (state.noticeDetail) {
        state.noticeDetail.title.ko = payload;
      }
    },
    setEnNoticeTitleChange(state, { payload }: PayloadAction<string>) {
      if (state.noticeDetail) {
        state.noticeDetail.title.en = payload;
      }
    },
    // 공지사항 내용 수정(+ 언어 변환)
    setKoNoticeContentChange(state, { payload }: PayloadAction<string>) {
      if (state.noticeDetail) {
        state.noticeDetail.content.ko = payload;
      }
    },
    setEnNoticeContentChange(state, { payload }: PayloadAction<string>) {
      if (state.noticeDetail) {
        state.noticeDetail.content.en = payload;
      }
    },
    // 공지사항 파일 수정
    setNoticeFileChange(state, { payload }: PayloadAction<{srcUrl: string, checkIndex: number, fileName: string}>) {
      const { srcUrl, checkIndex, fileName } = payload;
      if (state.noticeDetail) {
        state.noticeDetail.attachedFile[checkIndex].src = srcUrl;
        state.noticeDetail.attachedFile[checkIndex].fileName = fileName;
      }
    },
    // 공지사항 파일 추가
    setNoticeFileAdd(state, { payload }: PayloadAction<{srcUrl: string, fileName: string}>) {
      if (state.noticeDetail) {
        state.noticeDetail.attachedFile.push({
          src: payload.srcUrl,
          fileName: payload.fileName,
        });
      }
    },
    // 공지사항 파일 삭제
    deleteNoticeFile(state, { payload }: PayloadAction<number>) {
      state.noticeDetail.attachedFile.splice(payload, 1);
    },
    // 공지사항, 자주 묻는 질문 삭제
    removeDataList(state, { payload }: PayloadAction<{index: number, type: PublicBoardName}>) {
      // state.notice.data.splice(payload, 1);
      state[payload.type].data.splice(payload.index, 1);
    },
    // 공지사항 필터 기능
    setNoticeFilterChange(state, { payload }: PayloadAction<{listIndex:number, onOff: boolean, filterType: string }>) {
      const { listIndex, onOff, filterType } = payload;
      if (filterType === 'enabled') {
        state.notice.data[listIndex].isEnabled = onOff;
      }
      if (filterType === 'strong') {
        state.notice.data[listIndex].isStrong = onOff;
      }
    },
    // 자주 묻는 질문 제목 수정(+ 언어 변환)
    setKoFaqTitleChange(state, { payload }: PayloadAction<string>) {
      state.faqDetail.title.ko = payload;
    },
    setEnFaqTitleChange(state, { payload }: PayloadAction<string>) {
      state.faqDetail.title.en = payload;
    },
    // 자주 묻는 질문 내용 수정(+ 언어 변환)
    setKoFaqContentChange(state, { payload }: PayloadAction<string>) {
      state.faqDetail.content.ko = payload;
    },
    setEnFaqContentChange(state, { payload }: PayloadAction<string>) {
      state.faqDetail.content.en = payload;
    },
    // 자주 묻는 질문 수정 페이지 - 타입 수정
    setFaqTypeChange(state, { payload }: PayloadAction<number>) {
      state.faqDetail.boardFaqTypeID = payload;
    },
    // 자주 묻는 질문 기존 타입 수정
    setUpdateType(state, { payload }: PayloadAction<{indexNumber: number, changeName: string}>) {
      const { indexNumber, changeName } = payload;
      state.faqType[indexNumber].title = changeName;
    },
    // 이메일
    setEmailQuestion(state, { payload }: PayloadAction<(typeof state.emailQuestion)>) {
      state.emailQuestion = payload;
    },
    setEmailQuestionDetail(state, { payload }: PayloadAction<(typeof state.emailDetail)>) {
      state.emailDetail = payload;
    },
    // 이메일 답변 수정
    setEmailAnswerChange(state, { payload }: PayloadAction<string>) {
      state.emailDetail.answerInfo.content = payload;
    },
  },
);

export default communityBoardSlice;
